/* eslint-disable @typescript-eslint/no-explicit-any */ // TODO: Remove this disable and fix all any types in this file
import { ShopLight } from "@/abilities/shop/types/shop-light";
import {
    useAddCartItemMutation,
    useDeleteCartItemMutation,
    useGetShopLightCartLazyQuery,
    useUpdateCartItemMutation,
} from "@/shared/services/graphql/generated/consumer-graph-types";

// Helper: Transform GraphQL cart item to ShopLight.CartItem
function fromApiCartItem(item: any): ShopLight.CartItem {
    return {
        cartItemId: {
            articleId: item.cartItemId.articleId,
            partLocation: {
                mechanicId: item.cartItemId.partLocation?.mechanicId || "",
            },
        },
        quantity: item.quantity,
        remark: item.remark || "",
    };
}

export const useShopLightCartApi = () => {
    const getCart = async (): Promise<ShopLight.CartItem[]> => {
        const { load } = useGetShopLightCartLazyQuery();
        const result = await load();
        if (result) {
            const items = result.getCart?.cartItems || [];
            return items.map(fromApiCartItem) satisfies ShopLight.CartItem[];
        }
        return []; // Return empty array if no cart or error occurs
    };

    const addItem = async (item: ShopLight.CartItem): Promise<ShopLight.CartItem> => {
        const input = {
            cartItemId: item.cartItemId,
            quantity: item.quantity,
            remark: item.remark,
        };
        const { mutate } = useAddCartItemMutation();
        const result = await mutate({ spec: input });
        if (!result || !result.data || !result.data.addCartItem) {
            throw new Error("Failed to add cart item");
        }
        return fromApiCartItem(result.data.addCartItem) satisfies ShopLight.CartItem;
    };

    const deleteItem = async (item: ShopLight.CartItem): Promise<boolean> => {
        const input = {
            cartItemId: item.cartItemId,
        };
        const { mutate } = useDeleteCartItemMutation();
        const result = await mutate({ spec: input });
        return result?.data?.deleteCartItem || false;
    };

    const updateItem = async (item: ShopLight.CartItem): Promise<ShopLight.CartItem> => {
        const input = {
            cartItemId: item.cartItemId,
            quantity: item.quantity,
            remark: item.remark,
        };
        const { mutate } = useUpdateCartItemMutation();
        const result = await mutate({ spec: input });
        if (!result || !result.data || !result.data.updateCartItem) {
            throw new Error("Failed to update cart item");
        }
        return fromApiCartItem(result.data.updateCartItem) satisfies ShopLight.CartItem;
    };

    return {
        getCart,
        addItem,
        deleteItem,
        updateItem,
    };
};
